module.exports = __webpack_public_path__ + "img/labbanner1.ad7ae9e2.png";